var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.07,
    height: 22.818,
    viewBox: "0 0 91.07 22.818",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_192",
    "data-name": "Trazado 192",
    d: "M235.876,118.066a.3.3,0,0,1-.3.3h-5.591a2.8,2.8,0,0,0,2.648,2.648,2.605,2.605,0,0,0,2.3-1.181.3.3,0,0,1,.245-.143.271.271,0,0,1,.278.278.261.261,0,0,1-.042.143,3.165,3.165,0,0,1-2.783,1.459,3.491,3.491,0,1,1,3.246-3.5Zm-.6-.261a2.648,2.648,0,1,0-5.3,0Z",
    transform: "translate(-210.056 -104.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_193",
    "data-name": "Trazado 193",
    d: "M345.777,89.619a.287.287,0,0,1,.278.278.271.271,0,0,1-.278.278h-1.5V96.07a.281.281,0,0,1-.278.278.287.287,0,0,1-.278-.278V90.176h-1.442A.271.271,0,0,1,342,89.9a.281.281,0,0,1,.278-.278h1.442v-2.15a.3.3,0,0,1,.253-.3.276.276,0,0,1,.312.278v2.167Z",
    transform: "translate(-313.16 -79.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_194",
    "data-name": "Trazado 194",
    d: "M435.689,58.432V62a.287.287,0,0,1-.278.278.271.271,0,0,1-.278-.278V58.432a2.163,2.163,0,0,0-2.024-2.4c-1.72,0-2.462,1.5-2.361,3.044,0,.042.017.219.017.245v2.673a.3.3,0,0,1-.253.3.276.276,0,0,1-.312-.278V50.278a.281.281,0,0,1,.278-.278.287.287,0,0,1,.278.278v6.628a2.618,2.618,0,0,1,4.933,1.526Z",
    transform: "translate(-393.923 -45.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_195",
    "data-name": "Trazado 195",
    d: "M544.076,118.066a.3.3,0,0,1-.3.3h-5.591a2.8,2.8,0,0,0,2.648,2.648,2.605,2.605,0,0,0,2.3-1.181.3.3,0,0,1,.245-.143.271.271,0,0,1,.278.278.262.262,0,0,1-.042.143,3.165,3.165,0,0,1-2.783,1.459,3.491,3.491,0,1,1,3.247-3.5Zm-.607-.261a2.648,2.648,0,0,0-5.3,0Z",
    transform: "translate(-492.267 -104.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_196",
    "data-name": "Trazado 196",
    d: "M661.012,116.461a.284.284,0,0,1-.261.3,2.863,2.863,0,0,0-2.386,3.145v2.673a.3.3,0,0,1-.253.3.276.276,0,0,1-.312-.278v-6.1a.3.3,0,0,1,.253-.3.276.276,0,0,1,.312.278v1.24a2.983,2.983,0,0,1,2.344-1.526A.289.289,0,0,1,661.012,116.461Z",
    transform: "translate(-602.331 -106.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_197",
    "data-name": "Trazado 197",
    d: "M734.576,118.066a.3.3,0,0,1-.3.3h-5.591a2.8,2.8,0,0,0,2.648,2.648,2.605,2.605,0,0,0,2.3-1.181.3.3,0,0,1,.245-.143.271.271,0,0,1,.278.278.261.261,0,0,1-.042.143,3.165,3.165,0,0,1-2.783,1.459,3.491,3.491,0,1,1,3.246-3.5Zm-.6-.261a2.648,2.648,0,1,0-5.3,0Z",
    transform: "translate(-666.704 -104.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_198",
    "data-name": "Trazado 198",
    d: "M852.764,116.892v6.122a.287.287,0,0,1-.278.278.271.271,0,0,1-.278-.278V121.85a2.635,2.635,0,0,1-2.327,1.585,2.709,2.709,0,0,1-2.58-2.968v-3.584a.281.281,0,0,1,.278-.278.287.287,0,0,1,.278.278v3.584a2.163,2.163,0,0,0,2.024,2.4c1.88,0,2.327-1.762,2.327-3.71v-2.285a.283.283,0,0,1,.38-.261A.306.306,0,0,1,852.764,116.892Z",
    transform: "translate(-775.852 -106.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_199",
    "data-name": "Trazado 199",
    d: "M967.1,117.743v3.584a.287.287,0,0,1-.278.278.271.271,0,0,1-.278-.278v-3.584a2.148,2.148,0,0,0-2.024-2.386c-1.687,0-2.327,1.8-2.327,3.2v2.766a.287.287,0,0,1-.278.278.271.271,0,0,1-.278-.278v-3.584a2.148,2.148,0,0,0-2.024-2.386c-1.7,0-2.4,1.341-2.344,3.128,0,.042.017.118,0,.143v2.69a.3.3,0,0,1-.253.3.276.276,0,0,1-.312-.278v-6.114a.3.3,0,0,1,.253-.3.276.276,0,0,1,.312.278v1.02a2.681,2.681,0,0,1,2.344-1.425,2.5,2.5,0,0,1,2.386,1.779,2.768,2.768,0,0,1,2.521-1.779A2.7,2.7,0,0,1,967.1,117.743Z",
    transform: "translate(-876.027 -105.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M7,100.1l-7,3.179,7,4.14,7.007-4.14Z",
    transform: "translate(0 -91.659)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201",
    "data-name": "Trazado 201",
    d: "M0,11.62l7,4.14V0Z",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_202",
    "data-name": "Trazado 202",
    d: "M83,0V15.76l7.007-4.14Z",
    transform: "translate(-76.001)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_203",
    "data-name": "Trazado 203",
    d: "M0,153.6l7,9.866v-5.734Z",
    transform: "translate(0 -140.648)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_204",
    "data-name": "Trazado 204",
    d: "M83,157.732v5.734l7.007-9.866Z",
    transform: "translate(-76.001 -140.648)",
    fill: "#fff",
    opacity: 0.8
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth.557fa1d0e3ef3d33427be177307911b8.svg";